import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid general-widget" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'
import { strokeItem } from "@/core/data/dashboards"
import { series2, chartOptions21 } from "@/core/data/dashboards-chart"
import { useDashboardStore } from "@/store/dashboard"

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexGeneral',
  setup(__props) {

const StokeSell = defineAsyncComponent(() => import("@/components/common/StokeSell.vue"))
const InvestmentCard = defineAsyncComponent(() => import("@/components/theme/widgets/general/InvestmentCard.vue"))
const SwiperSlide = defineAsyncComponent(() => import("@/components/common/SwiperSlide.vue"))
const WidgetContent = defineAsyncComponent(() => import("@/components/theme/widgets/general/WidgetContent.vue"))
const RadialCard = defineAsyncComponent(() => import("@/components/theme/widgets/general/RadialCard.vue"))
const SmallWidget = defineAsyncComponent(() => import("@/components/theme/widgets/general/SmallWidget.vue"))
const ScheduleView = defineAsyncComponent(() => import("@/components/common/ScheduleView.vue"))
const UpcomingClasses = defineAsyncComponent(() => import("@/components/common/UpcomingClasses.vue"))
const MonthlyRevenue = defineAsyncComponent(() => import("@/components/common/MonthlyRevenue.vue"))
let store = useDashboardStore()
let swipers = store.swipersitem

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Widgets",
      mains: "General",
      title: "General"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(StokeSell), {
          height: "110",
          mainClass: "col-xl-3 col-sm-6 box-col-6",
          colClass: "col-md-12 col-xl-12 col-lg-12",
          data: _unref(strokeItem)
        }, null, 8, ["data"]),
        _createVNode(_unref(InvestmentCard)),
        _createVNode(_unref(SwiperSlide), {
          colClass: "col-xl-3 col-sm-6 box-col-6",
          data: _unref(swipers)
        }, null, 8, ["data"]),
        _createVNode(_unref(WidgetContent)),
        _createVNode(_unref(RadialCard)),
        _createVNode(_unref(SmallWidget)),
        _createVNode(_unref(ScheduleView), { colClass: "col-sm-6 col-xl-3 d-xxl-block d-xl-none box-col-none" }),
        _createVNode(_unref(UpcomingClasses), {
          colClass: "col-sm-6 col-xxl-3 box-col-6",
          cardClass: "card "
        }),
        _createVNode(_unref(MonthlyRevenue), {
          colClass: "col-xl-6 box-col-6 growth-card",
          cardClass: "card",
          series: _unref(series2),
          option: _unref(chartOptions21)
        }, null, 8, ["series", "option"])
      ])
    ])
  ], 64))
}
}

})